import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import Swal from 'sweetalert2';
import axios from "axios";
import { API_BASE_URL } from "../../../Helpers/apiConfig";

const ChangePassword = () => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const [msgPSW, setMsgPSW] = useState("");

    const change = async (e) => {
        e.preventDefault();
        const form = e.target;
        const newPassword = document.getElementById("newpassword").value;
        const newPasswordVerify = document.getElementById("newpasswordcheck").value;

        // Mevcut şifre sorulmuyor; yeni şifre iki kez girilip karşılaştırılıyor (B1).
        if (newPassword !== newPasswordVerify) {
            const message = "Girdiğiniz yeni şifreler aynı değil. Lütfen kontrol edip tekrar deneyin.";
            Swal.fire({
                title: t("error"),
                text: message,
                icon: "error",
                confirmButtonText: "Tamam"
            });
            setMsgPSW(message);
            return;
        }

        try {
            const headerss = {
                "accept": "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                "Authorization": "Bearer " + user.token
            };

            const res = await axios.post(
                API_BASE_URL + "/user/Opt/UpdatePassword",
                {
                    newPassword: newPassword,
                    newPasswordVerify: newPasswordVerify,
                },
                { headers: headerss }
            );

            if (res.status === 200 && res.data.success) {
                Swal.fire({
                    title: "Başarılı",
                    text: "Şifreniz başarıyla değiştirildi.",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                setMsgPSW("");
                form.reset();
            } else {
                Swal.fire({
                    title: t("error"),
                    text: res.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam"
                });
                setMsgPSW(res.data.message);
            }
        } catch (err) {
            setMsgPSW(err.message);
        }
    };

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6">

                    <div className="card shadow-sm">
                        <div className="card-body">

                            <h3 className="text-center mb-4">
                                {t("changepassword")}
                            </h3>

                            {msgPSW && (
                                <div className="alert alert-warning text-center">
                                    {msgPSW}
                                </div>
                            )}

                            <form onSubmit={change}>

                                <div className="mb-3">
                                    <label
                                        htmlFor="newpassword"
                                        className="form-label"
                                    >
                                        {t("newpassword")}
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="newpassword"
                                        required
                                    />
                                </div>

                                <div className="mb-4">
                                    <label
                                        htmlFor="newpasswordcheck"
                                        className="form-label"
                                    >
                                        Yeni Şifreyi tekrar giriniz.
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="newpasswordcheck"
                                        required
                                    />
                                </div>

                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                    >
                                        {t("changepassword")}
                                    </button>
                                </div>

                            </form>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
